"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Username = void 0;
const react_1 = __importDefault(require("react"));
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_text_text_1 = require("@unboared/base-ui.text.text");
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const react_native_1 = require("react-native");
function Username({ name, color, style, textStyle, master, size }) {
    const mainTheme = (0, rn_css_1.useTheme)();
    let currentTheme = mainTheme || base_ui_theme_themes_1.defaultTheme;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const normalizedSize = normalize(size || currentTheme.sizeP);
    const containerStyle = [
        {
            backgroundColor: color,
            borderRadius: color && 1.5 * normalizedSize,
            paddingVertical: color && 0.5 * normalizedSize,
            paddingHorizontal: color && 2 * normalizedSize
        },
        style
    ];
    const titleStyle = [
        {
            color: color ? base_ui_theme_colors_1.base_color.light : currentTheme.buttonTextColor,
            fontFamily: currentTheme.buttonFont || 'unset',
            fontSize: normalizedSize,
            fontWeight: 'bold'
        },
        textStyle
    ];
    return (react_1.default.createElement(react_native_1.View, { style: containerStyle },
        react_1.default.createElement(base_ui_text_text_1.Text, { style: titleStyle, text: (master ? "👑 " + name : name) })));
}
exports.Username = Username;
//# sourceMappingURL=username.js.map